// extracted by mini-css-extract-plugin
var _1 = "OTPWithResendSubmit-module__divcontainer__pUDId";
var _2 = "OTPWithResendSubmit-module__sign_in_Heading__LZn3D";
var _3 = "OTPWithResendSubmit-module__sign_up__V3Ykp";
var _4 = "OTPWithResendSubmit-module__sign_up_a__JAWwB";
var _5 = "OTPWithResendSubmit-module__signup_h3__YFKQX";
var _6 = "OTPWithResendSubmit-module__submit_button__gfGj9";
export { _1 as "divcontainer", _2 as "sign_in_Heading", _3 as "sign_up", _4 as "sign_up_a", _5 as "signup_h3", _6 as "submit_button" }
